import { IntentChoicePath } from './HomeChatPanel.types';




export const ACTION_CHOICE_UNAVAILABLE_COPY =
  'This option is no longer available for this question. Ask this question again, or ask a new question.';

export const INTENT_CHOICE_UNAVAILABLE_COPY =
  'That choice is no longer available. Please start a new chat or send another message.';

export function selectionErrorMessage(raw: unknown): string | null {
  if (!raw || typeof raw !== 'object') return null;
  const response = raw as { status?: unknown; error?: unknown };
  return response.status === 'error' && typeof response.error === 'string' && response.error.trim()
    ? response.error
    : null;
}

/**
 * Labels are part of the normalized, server-issued card contract. They are
 * used only to select the matching presentation/loading surface; the opaque
 * selection key remains the only action value sent back to the server.
 */
export function intentChoicePathForLabel(label: string): IntentChoicePath | null {
  // These exact composite labels are the server-owned public chooser
  // contract. Their action mapping stays server-side behind an opaque key;
  // this branch selects only the appropriate local pending presentation.
  if (label === 'Research products and suppliers — Commodities Market Research') return 'mr';
  if (label === 'Commodities Market Research') return 'mr';
  if (label === 'Buy with a purchase card — GPC') return 'gpc';
  if (label === 'Buy with a Government Purchase Card') return 'gpc';
  if (label === 'Get procurement guidance') return 'qa';
  if (label === 'Search similar requirements') return 'similar_requirements';
  if (label === 'Start a GPC purchase') return 'gpc';
  return null;
}

/**
 * Action-choice labels are server-authored presentation text. They never
 * select a route in the browser, but they let the card acknowledge a click
 * with useful, route-appropriate progress while its opaque key is in flight.
 */
export function actionChoicePendingLabel(label: string): string {
  const normalized = label.trim().toLocaleLowerCase();
  if (normalized.includes('market research')) return 'Generating Context Questions…';
  if (normalized.includes('gpc') || normalized.includes('purchase card')) return 'Starting your GPC purchase…';
  if (normalized.includes('similar')) return 'Searching similar requirements…';
  if (normalized.includes('procurement guidance')) return 'Preparing procurement guidance…';
  return 'Opening your selection…';
}

export const HOME_NAVIGATION_CHECKPOINT = Object.freeze({ editRevision: -1 });
